import { Component, EventEmitter, OnInit, Output, effect } from '@angular/core';
import { CareerChecklistStore } from '@app/services/signals/career-checklist-service';
import { BYP_PLAN_GENERATED_LOCAL_KEY } from '@app/utils/constants';
import { analytics } from '@app/events/segment/analytics';

@Component({
  selector: 'app-generate-plan',
  imports: [],
  templateUrl: './generate-plan.component.html',
  styleUrl: './generate-plan.component.css'
})
export class GeneratePlanComponent implements OnInit {
  @Output() planGenerateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public planUnlocked: boolean = false;

  constructor(private checklistStore: CareerChecklistStore) {
    effect(() => {
      this.planUnlocked = this.checklistStore.generatePlanUnlocked();
    });
  }

  ngOnInit() {
    this.planUnlocked = this.checklistStore.generatePlanUnlocked();
  }

  onClickBtn() {
    if (this.planUnlocked) {
      analytics.track('Plan Generate', { section: 'plan' });
      this.planGenerateEmitter.emit();
    }
  }
}
